import { useNavigate } from "react-router-dom";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import ProjectFormEditor from "./ProjectForm";

export default function ProjectFormPage() {
  const nav = useNavigate();
  const [searchParams] = useSearchParams();

  const handleSave = (project) => {
    toast.success("Project created");
    nav(`/app/projects/${project.id}`);
  };

  const tab = searchParams.get("tab") || "active";

  return (
    <div className="p-8 lg:p-12 max-w-4xl mx-auto" data-testid="project-form-page">
      <Link
        to={`/app/projects?tab=${tab}`}
        className="inline-flex items-center gap-2 type-body-sm text-[#475569] hover:text-[#0F1F3D]"
      >
        <ArrowLeft className="h-4 w-4" /> Back to projects
      </Link>
      <h1 className="type-h1 text-[#0F1F3D] mt-4">New project</h1>

      <ProjectFormEditor onSave={handleSave} />
    </div>
  );
}
